import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './ui-arrow-button.css?inline';
import '../ui-icons/ui-chevron-arrow-icon';

const CName = 'ui-arrow-button';

export const ArrowDirection = {
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up',
} as const;

export type ArrowDirection = (typeof ArrowDirection)[keyof typeof ArrowDirection];

/**
 * @prop {string} ariaLabel - Aria-label for accessibility purposes.
 * @prop {string} arrowDirection - Direction in which the arrow points. It can be 'down', 'left', 'right', or 'up'.
 * @fires clicked - Fired when the button is clicked.
 */
@customElement(CName)
export class UIArrowButton extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String }) ariaLabel = '';
  @property({ type: String }) arrowDirection = ArrowDirection.RIGHT;
  @property({ type: String }) buttonClass = '';

  render() {
    return html`
      <div class="btn-wrapper ${this.arrowDirection}">
        <button
          aria-label=${this.ariaLabel}
          class=${this.buttonClass}
          @click=${() => this.dispatchEvent(new CustomEvent('clicked'))}
        >
          <ui-chevron-arrow-icon arrowDirection=${this.arrowDirection}></ui-chevron-arrow-icon>
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIArrowButton;
  }
}
